import * as ActionType from "./gift.type";

const initialState = {
  gift: [],
};

export const giftReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_GIFT:
      return {
        ...state,
        gift: action.payload,
      };

    case ActionType.UPDATE_GIFT:
      return {
        ...state,
        gift: state.gift.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
      };

    case ActionType.DELETE_GIFT:
      return {
        ...state,
        gift: state.gift.filter(
          (data) => data._id !== action.payload && data
        ),
      };

    case ActionType.CREATE_GIFT:
      let data = [...state.gift];
      data.unshift(action.payload);
      return {
        ...state,
        gift: data,
      };

    default:
      return state;
  }
};
